import { render, staticRenderFns } from "./SelectClassrooms.vue?vue&type=template&id=f0b90dc0"
import script from "./SelectClassrooms.vue?vue&type=script&lang=js"
export * from "./SelectClassrooms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports